import { ReactComponent as AccountSVG } from "assets/icons/sidenav/account.svg";
import { ReactComponent as RecorderSVG } from "assets/icons/sidenav/recorder.svg";
import { ReactComponent as AlertSVG } from "assets/icons/sidenav/alerts.svg";
import { ReactComponent as VideoSVG } from "assets/icons/sidenav/videoshare.svg";
import { ReactComponent as BillingSVG } from "assets/icons/sidenav/billing.svg";
import { ReactComponent as ReportSVG } from "assets/icons/sidenav/reports.svg";
import { ReactComponent as UserSVG } from "assets/icons/sidenav/users.svg";
import { ReactComponent as ManageSVG } from "assets/icons/sidenav/settings.svg";
import helpSVG from "assets/icons/sidenav/help.svg";
import settingSVG from "assets/icons/sidenav/settings.svg";
import {
  RoutesProp,
  RoutesProps,
  SwitchAccountQueryString,
} from "api/interfaces/menuInterface.interface";

import {
  ProfileAccountInfo,
  ProfileAccountInfoFromServer,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";

import {
  StrictUserPermissionKey,
  UserGroupUserPermission,
} from "api/interfaces/userInterface.interface";
import { NavigateFunction } from "react-router-dom";
import { debounce } from "lodash";
import { allSubcriptionPermission } from "pages/users/userGroup/add/PermissionPolicy";
import { GrConfigure } from "react-icons/gr";
import { getRoleId } from "./lastPathUtil";
import { isHiddenGroup } from "utils/AccountUtil";
import { getStartPageUrl } from "utils/functions";
import { checkIsSubCP } from "./AccountUtil";
import {
  SUBSCRIPTION_LOCATION,
} from "api/interfaces/subscription.interface";

export type RequiredPermissionType =
  | StrictUserPermissionKey
  | StrictUserPermissionKey[]
  | "rw"
  | undefined;

export const dwMenuData: Array<RoutesProps> = [
  {
    svg: null,
    name: "Dashboard",
    routeName: "/dashboard",
    includeRouteName: "/dashboard",
    isRole: "rw",
    isSidebar: false,
    children: [
      {
        svg: null,
        isRole: "rw",
        name: "Map",
        routeName: "/dashboard/map",
        ishidden: false,
      },

      {
        svg: null,
        isRole: [
          "viewAccount",
          "viewUsersAndGroups",
          "subscriptionOrganization",
          "subscriptionKeys",
        ],
        name: "Stats",
        routeName: "/dashboard/admin",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "rw",
        name: "Widgets",
        routeName: "/dashboard/chart",
        ishidden: false,
      },
    ],
    ishidden: true,
  },
  {
    svg: <AccountSVG />,
    name: "Organization",
    routeName: "/account",
    includeRouteName: "/account",
    disabled: false,
    isRole: "viewAccount",
    isSidebar: true,
    ishidden: false,
    children: [],
  },
  {
    svg: <RecorderSVG />,
    name: "Recorders",
    routeName: "/recorders/list",
    includeRouteName: "/recorders",
    disabled: false,
    isRole: "viewRecordersAndGroups",
    isSidebar: true,
    ishidden: true,
    children: [
      {
        svg: null,
        isRole: "viewRecordersAndGroups",
        name: "Recorders",
        title: "Recorder List",
        routeName: "/recorders/list",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "viewRecordersAndGroups",
        name: "Recorder Groups",
        title: "Recorder Groups",
        routeName: "/recorders/groups",
        ishidden: false,
      },
    ],
  },
  {
    svg: <AlertSVG />,
    name: "Alert",
    routeName: "/alert/active",
    includeRouteName: "/alert",
    disabled: false,
    isRole: "viewAlerts",
    isSidebar: true,
    ishidden: false,
    children: [
      {
        svg: null,
        isRole: "viewAlerts",
        name: "Alerts",
        title: "Alert",
        routeName: "/alert/active",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "viewAlerts",
        name: "Alert History",
        title: "Alert History",
        routeName: "/alert/history",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "viewAlerts",
        name: "Rules",
        title: "Rules",
        routeName: "/alert/rules",
        ishidden: false,
      },
    ],
  },
  {
    svg: <VideoSVG />,
    name: "Video Share",
    routeName: "/videoShare",
    includeRouteName: "/videoShare",
    ishidden: false,
    disabled: false,
    isRole: "view",
    isSidebar: true,
    children: [],
  },
  {
    svg: <ReportSVG width={20} height={24} />,
    name: "Reports",
    routeName: "/reports",
    includeRouteName: "/reports",
    disabled: false,
    isRole: "viewReports",
    isSidebar: true,
    ishidden: false,
    children: [
      {
        svg: null,
        isRole: "viewReports",
        name: "",
        title: "Report List",
        routeName: "/reports",
        ishidden: false,
      },
    ],
  },
  {
    svg: <UserSVG />,
    name: "Users",
    routeName: "/users/list",
    includeRouteName: "/users",
    disabled: false,
    isRole: "viewUsersAndGroups",
    ishidden: false,
    isSidebar: true,
    children: [
      {
        svg: null,
        isRole: "viewUsersAndGroups",
        name: "Users",
        title: "User List",
        routeName: "/users/list",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "viewUsersAndGroups",
        name: "User Groups",
        title: "User Groups",
        routeName: "/users/groups",
        ishidden: false,
      },
    ],
  },
  {
    svg: <BillingSVG width={20} height={24} />,
    name: "Subscription",
    routeName: "/subscription/organization",
    includeRouteName: "/subscription",
    disabled: false,
    isSidebar: true,
    isRole: allSubcriptionPermission,
    ishidden: false,
    children: [
      {
        svg: null,
        isRole: "manageBillingAndLicenses",
        name: "Usage Based Plan",
        title: "Usage Based Plan",
        routeName: "/subscription/usage",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "subscriptionOrganization",
        name: "Organization",
        title: "Organization",
        routeName: "/subscription/organization",
        ishidden: false,
      },
      {
        svg: null,
        isRole: ["subscriptionKeys", "manageBillingAndLicenses"],
        name: "Subscription Key Plan",
        title: "Subscription Key Plan",
        routeName: "/subscription/keys",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "serviceAndPricing",
        name: "Services & Pricing",
        title: "Services & Pricing",
        routeName: "/subscription/services",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "cumulus",
        name: "DW Cumulus",
        title: "DW Cumulus",
        routeName: "/subscription/lyve",
        ishidden: false,
      },
    ],
  },

  {
    svg: settingSVG,
    name: "Settings",
    routeName: "/settings",
    includeRouteName: "/settings",
    isRole: "rw",
    ishidden: false,
    children: [
      {
        svg: null,
        isRole: "rw",
        name: "My Profile",
        routeName: "/settings/myaccount",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "myOrganization",
        name: "My Organization",
        routeName: "/settings/adminAccount",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "myOrganization",
        name: "Information",
        routeName: "/settings/information",
        ishidden: false,
      },
    ],
  },
  {
    svg: helpSVG,
    name: "Help",
    routeName: "/help/videoguides",
    includeRouteName: "/help",
    isRole: "rw",
    ishidden: false,
    children: [
      {
        svg: null,
        isRole: "rw",
        name: "myDW Guides",
        title: "myDW Guides",
        routeName: "/help/videoguides",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "rw",
        name: "Tech Support",
        title: "Tech Support",
        routeName: "/help/techsupport",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "rw",
        name: "Contact",
        title: "Contact",
        routeName: "/help/contact",
        ishidden: false,
      },
      // {
      //   svg: null,
      //   isRole: "rw",
      //   name: "Setup Guide",
      //   title: "Setup Guide",
      //   routeName: "/help/setupguide",
      //   ishidden: false,
      // },
      // {
      //   svg: null,
      //   isRole: "rw",
      //   name: "Speed Test",
      //   title: "Speed Test",
      //   routeName: "/help/speedtest",
      //   ishidden: false,
      // },
      {
        svg: null,
        isRole: "rw",
        name: "About",
        title: "About",
        routeName: "/help/about",
        ishidden: false,
      },
    ],
  },
  {
    svg: <ManageSVG />,
    name: "Management",
    routeName: "/manager/guideSetting",
    includeRouteName: "/manager",
    disabled: false,
    isRole: [
      "videoGuideSetting",
      "techSupport",
      "siteNotice",
      "emails",
      "logging",
      "announcement",
      "releaseNotes",
    ],
    isSidebar: true,
    ishidden: false,
    children: [
      {
        svg: null,
        isRole: "videoGuideSetting",
        name: "myDW Guide Setting",
        title: "myDW Guide Setting",
        routeName: "/manager/guideSetting",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "techSupport",
        name: "Tech Support",
        title: "Tech Support",
        routeName: "/manager/techSummit",
        ishidden: false,
      },
      // {
      //   svg: null,
      //   isRole: "rw",
      //   name: "Operation Log",
      //   title: "Operation Log",
      //   routeName: "/manager/operationLog",
      //   ishidden: false,
      // },
      {
        svg: null,
        isRole: "siteNotice",
        name: "Site Notices",
        routeName: "/manager/sitenotices",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "emails",
        name: "Emails",
        routeName: "/manager/emails",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "logging",
        name: "Logging",
        routeName: "/manager/operationLog",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "announcement",
        name: "Announcement",
        routeName: "/manager/features",
        ishidden: false,
      },
      {
        svg: null,
        isRole: "releaseNotes",
        name: "Release Notes",
        routeName: "/manager/releaseNotes",
        ishidden: false,
      },
    ],
  },
  {
    svg: <GrConfigure className="maintenance-icon" />,
    name: "Maintenance",
    routeName: "/maintenance",
    includeRouteName: "/maintenance",
    disabled: false,
    isRole: "manageMaintenance",
    isSidebar: true,
    ishidden: false,
    children: [
      {
        svg: null,
        isRole: ["manageMaintenance"],
        name: "Firmware",
        routeName: "/maintenance/firmware",
        ishidden: false,
      },
      {
        svg: null,
        isRole: ["manageMaintenance"],
        name: "COVA Config Download",
        routeName: "/maintenance/configuration",
        ishidden: false,
      },
      {
        svg: null,
        isRole: ["manageMaintenance"],
        name: "Staging Recorder",
        routeName: "/maintenance/staging",
        ishidden: false,
      },
      {
        svg: null,
        isRole: ["manageMaintenance"],
        name: "Admin Temporary Password Generator",
        routeName: "/maintenance/adminUnlock",
        ishidden: false,
      },
    ],
  },
];

// menuData 에서 해당 location 메뉴 찾기
export const findMenuByRouteName = (
  targetRouteName: string
): RoutesProps | null => {
  for (const route of dwMenuData) {
    if (route.routeName === targetRouteName) {
      return route;
    }

    if (route.children) {
      const foundChild = route.children.find(
        (child) => child.routeName === targetRouteName
      );
      if (foundChild) {
        return route;
      }
    }
  }

  return null;
};

const debouncedNavigate = debounce(
  (
    navigate: NavigateFunction,
    to: string,
    replace?: boolean,
    state?: any,
    queryString?: Object
  ) => {
    const accountId =
      typeof state?.selectedAccount === "string"
        ? state.selectedAccount
        : state?.selectedAccount?.accountId;

    const searchParams = new URLSearchParams();

    if (accountId) {
      searchParams.set("account", accountId);
    }

    if (queryString) {
      Object.entries(queryString).forEach(([key, value]) => {
        searchParams.set(key, String(value));
      });
    }
    if (!searchParams.get("r")) {
      searchParams.set(
        "r",
        getRoleId({
          accountId: accountId,
        }) as string
      );
    }

    navigate(
      {
        pathname: to,
        search: searchParams.toString() ? `?${searchParams.toString()}` : "",
      },
      { replace, state }
    );
  },
  300
);

export const menuNavigation = (
  selectedAccount: ProfileAccountInfo | ProfileAccountInfoFromServer | string,
  navigate: NavigateFunction,
  to: string,
  replace?: boolean,
  state?: any,
  queryString?: Object
) => {
  debouncedNavigate(
    navigate,
    to,
    replace,
    { ...state, selectedAccount },
    queryString
  );
};

export const logoutAbleUrl = [
  "/reset",
  "/guest/video/player",
  "/signup",
  "/login/free-trial",
  "/terms/eula",
  "/terms/sla",
  "/terms/cookie-policy",
  "/tmp-access/confirm",
  "/login/setup-passkey",
  "/callback",
  "/reseller",
  "/verify/2fa",
];
export const normalAbleUrl = [
  "/error/403",
  "/404",
  "/subscription/usage/payment/success",
];

export const checkIsChildHasPermission = (
  isRole: RoutesProp["isRole"],
  account: ProfileAccountInfo
) => {
  if (!isRole) {
    return true;
  }

  if (Array.isArray(isRole)) {
    return isRole.some((role) => {
      if (role === "rw") {
        return true;
      }

      return (
        account.userPermission[role as keyof UserGroupUserPermission] === true
      );
    });
  }

  if (isRole === "rw") {
    return true;
  }

  if (isRole === "myOrganization") {
    return !account.isHidden;
  }

  return (
    account.userPermission[isRole as keyof UserGroupUserPermission] === true
  );
};

export type CheckRolePermissionFn = (
  route: RoutesProps,
  account?: ProfileAccountInfo
) => boolean;

export function checkPermissionChildren({
  targetMenu,
  account,
  pathname,
  checkRolePermission,
}: {
  targetMenu?: RoutesProps | null;
  account: ProfileAccountInfo;
  pathname: string;
  checkRolePermission: CheckRolePermissionFn;
}): boolean {
  if (!targetMenu) {
    return false;
  }

  if (!targetMenu.children?.length) {
    return checkRolePermission(targetMenu, account);
  }

  const path = normalizeMenuPath(pathname);

  const child = targetMenu.children.find((c) => {
    let rn = c.routeName || "";
    if (!rn) return false;
    const nr = normalizeMenuPath(rn);
    return path === nr || path.startsWith(`${nr}/`);
  });

  if (child?.isRole) {
    return checkIsChildHasPermission(child.isRole, account);
  }

  /** /manager 처럼 부모 index만 열린 경우 — 자식 routeName이 전부 /manager/xxx 라 startsWith 매칭이 안 됨 */
  const include = targetMenu.includeRouteName
    ? normalizeMenuPath(targetMenu.includeRouteName)
    : "";
  if (include && path === include) {
    return targetMenu.children.some(
      (c) => c.isRole && checkIsChildHasPermission(c.isRole, account)
    );
  }

  return false;
}

export const getAllowedStartPage = (
  targetPage: number,
  fallback: number,
  userPermission: UserGroupUserPermission
) => {
  const menu = findMenuByRouteName(getStartPageUrl(targetPage));
  const roleKey = menu?.isRole as keyof UserGroupUserPermission;
  return userPermission[roleKey] ? targetPage : fallback;
};

export const adjustedStartPage = (
  userAccount: ProfileAccountInfo,
  startPage: number
): number => {
  const { accountLevel, userPermission } = userAccount;
  const isDW = accountLevel === LEVEL_TYPE.DW;
  const isEU = accountLevel === LEVEL_TYPE.EU;
  const suspend = userAccount.isEnabled;

  if (isDW && startPage < 3) {
    return getAllowedStartPage(3, 3, userPermission);
  }
  if (!isDW && startPage === 3) {
    return getAllowedStartPage(1, 1, userPermission);
  }
  if (isEU && !suspend) {
    return getAllowedStartPage(5, 1, userPermission);
  }
  if (startPage === 4 || startPage === 5) {
    if (isEU) {
      return getAllowedStartPage(5, 1, userPermission);
    }
    return getAllowedStartPage(4, isDW ? 3 : 1, userPermission);
  }
  return startPage;
};

export function getPermittedPath({
  pathname,
  account,
  startPage,
  checkRolePermission,
  unleashFlags,
}: {
  pathname: string;
  account: ProfileAccountInfo;
  startPage: number;
  checkRolePermission: CheckRolePermissionFn;
  unleashFlags: Record<string, boolean>;
}): string {
  const menusForRouting = buildMenuListsForAccount({
    account,
    checkRolePermission,
    unleashFlags,
  });

  const hasPermission = hasPermissionForPath({
    pathname,
    account,
    checkRolePermission,
    unleashFlags,
  });

  if (hasPermission) {
    return pathname;
  }

  const fallbackUrl = getStartPageUrl(adjustedStartPage(account, startPage));

  const hasPermissionFallback = hasPermissionForPath({
    pathname: fallbackUrl,
    account,
    checkRolePermission,
    unleashFlags,
  });

  if (fallbackUrl !== pathname && hasPermissionFallback) {
    return fallbackUrl;
  }

  const firstAccessMenu = menusForRouting.find((item) => {
    const child = item.children?.[0];
    if (child?.routeName) {
      return checkIsChildHasPermission(child.isRole, account);
    }
    return checkIsChildHasPermission(item.isRole, account);
  });

  const targetRoute =
    firstAccessMenu?.children?.[0]?.routeName || firstAccessMenu?.routeName;

  return targetRoute || fallbackUrl;
}

export function filterRolesForMenu(children: RoutesProps["children"]) {
  let roles: string[] = [];
  children?.forEach((child: RoutesProp) => {
    if (Array.isArray(child.isRole)) {
      child.isRole.forEach((role) => {
        if (!roles.includes(role)) {
          roles.push(role);
        }
      });
    } else if (child.isRole && !roles.includes(child.isRole as string)) {
      roles.push(child.isRole as string);
    }
  });
  if (roles.includes("rw")) {
    return "rw";
  }
  return roles;
}

export function checkRoleMenu({
  permission,
  isRole,
  userPermission,
  account,
}: {
  permission: boolean;
  isRole: string | string[];
  userPermission: UserGroupUserPermission;
  account: ProfileAccountInfo;
}) {
  if (Array.isArray(isRole)) {
    permission = isRole.some(
      (role) =>
        role === "rw" ||
        userPermission[role as keyof UserGroupUserPermission] === true
    );
  } else if (isRole === "rw") {
    return true;
  } else {
    if (
      !account.isEnabled &&
      ((isRole.includes("manage") && isRole !== "manageBillingAndLicenses") ||
        account.accountLevel === LEVEL_TYPE.CP)
    ) {
      return false;
    }
    permission =
      userPermission[isRole as keyof UserGroupUserPermission] === true;
  }
  return permission;
}
export function buildMenuListsForAccount({
  account,
  checkRolePermission,
  unleashFlags,
}: {
  account: ProfileAccountInfo;
  checkRolePermission: (
    route: RoutesProps,
    acc?: ProfileAccountInfo
  ) => boolean;
  unleashFlags: Record<string, boolean>;
}): RoutesProps[] {
  const { isEnabled } = account;
  const isDW = account.accountLevel === LEVEL_TYPE.DW;
  const isCP = account.accountLevel === LEVEL_TYPE.CP;
  const isEU = account.accountLevel === LEVEL_TYPE.EU;
  return dwMenuData
    .map((list) => {
      let filterChildren = (list.children || []).filter((child) => {
        if (
          child.routeName === "/subscription/usage" &&
          unleashFlags.isPlanHide
        ) {
          return false;
        }
        if (checkRolePermission(child, account)) {
          if (child.name === "Organization") {
            return account.accountLevel !== LEVEL_TYPE.EU;
          }
          if (child.isRole === "myOrganization") {
            if (child.routeName === "/settings/information") {
              return (
                account.accountLevel === LEVEL_TYPE.CP &&
                !account.isHidden &&
                account.isAdminGroup
              );
            }
            return !account.isHidden && account.isAdminGroup;
          }
          return !!child.name;
        }
        return false;
      });
      const roles =
        filterChildren.length > 0
          ? filterRolesForMenu(filterChildren)
          : list.isRole;
      let routeName: string = list.routeName ?? "";
      if (
        filterChildren &&
        filterChildren.length > 0 &&
        filterChildren[0].routeName
      ) {
        routeName = filterChildren[0].routeName;
      }
      let result = {
        ...list,
        ishidden: false,
        disabled: false,
        children: filterChildren,
        routeName: routeName,
        isRole: roles,
      } as unknown as RoutesProps;

      if (isDW && routeName.includes("/dashboard")) {
        return {
          ...result,
          isRole:
            (result.children || []).find(
              (child) => child.routeName === "/dashboard/admin"
            )?.isRole ?? result.isRole,
        };
      }

      if (routeName.includes("/maintenance")) {
        return {
          ...result,
          routeName: "/maintenance",
          children: result.children?.filter((child) => {
            if (child.routeName === "/maintenance/firmware") {
              return unleashFlags.isFirmwareUpgradeEnable && (isEU || isDW);
            }
            if (child.routeName === "/maintenance/configuration") {
              return unleashFlags.isCovaConfigEnable && isEU;
            }
            if (child.routeName === "/maintenance/staging") {
              return unleashFlags.isStagingRecorderEnable && isCP;
            }
            return true;
          }),
          disabled: !account.isEnabled || account.isHidden,
          hidden: account.isHidden,
        };
      }
      if (list.includeRouteName === "/subscription") {
        if (checkIsSubCP(account)) {
          return {
            ...result,
            children: result.children?.map((child) =>
              child.routeName === "/subscription/usage"
                ? { ...child, ishidden: true, disabled: true }
                : child
            ),
          };
        }
        if (isEU) {
          return {
            ...result,
            routeName: "/subscription/organization/history",
            isRole: "viewSubscription",
            ishidden: !account.userPermission.viewSubscription,
            disabled: !account.userPermission.viewSubscription,
            children: [],
          };
        }
        if (isDW) {
          return {
            ...result,
            children: result.children?.map((child) => {
              if (child.routeName === "/subscription/keys") {
                return {
                  ...child,
                  name: "Keys",
                };
              }
              return child;
            }),
          };
        }
      }

      if (isEU) {
        if (routeName.includes("/account")) {
          return { ...result, ishidden: true };
        }

        if (routeName.includes("/videoShare")) {
          return {
            ...result,
            ishidden: account.isHidden,
            disabled: account.isHidden,
          };
        }

        if (!isEnabled) {
          if (["/reports", "/alert"].some((p) => routeName.includes(p))) {
            return { ...result, disabled: true };
          }
          return result;
        }

        return result;
      }

      if (
        routeName.includes("/recorder") ||
        routeName.includes("/videoShare")
      ) {
        return { ...result, ishidden: true };
      }
      if (isCP) {
        return {
          ...result,
          disabled: !isEnabled,
        };
      }

      if (routeName.includes("/alert") || routeName.includes("/reports")) {
        return {
          ...result,
          ishidden: isDW,
        };
      }

      return {
        ...result,
        ishidden: !checkRoleMenu({
          permission: result.ishidden ?? false,
          isRole: result.isRole,
          userPermission: account.userPermission,
          account,
        }),
        isRole:
          result.children && result.children.length > 0
            ? filterRolesForMenu(result.children)
            : result.isRole,
      };
    })
    .filter((item) => item.ishidden !== true);
}

export function getSwitchAccountRoleId(isHidden: boolean): string {
  return (
    isHidden ? localStorage.getItem("r-hid") : localStorage.getItem("r-mem")
  ) as string;
}

export function mergeSwitchAccountQueryString(
  queryString: SwitchAccountQueryString | undefined,
  roleId: string
): SwitchAccountQueryString {
  return {
    ...(queryString ?? {}),
    r: roleId,
  };
}

export function shouldRequire2faForSwitchAccount({
  isVerified,
  userVerify2fa,
  accountUse2faAuth,
  userPermission,
}: {
  isVerified?: boolean;
  userVerify2fa: boolean;
  accountUse2faAuth?: boolean;
  userPermission: UserGroupUserPermission[];
}): boolean {
  return (
    !isVerified &&
    !userVerify2fa &&
    !!accountUse2faAuth &&
    !isHiddenGroup(userPermission)
  );
}

export function buildVerify2faNavigatePayload({
  selectAccount,
  verifyType,
  email,
  phone,
  userKey,
}: {
  selectAccount: ProfileAccountInfoFromServer;
  verifyType: string | undefined;
  email: string;
  phone: string | undefined;
  userKey: string;
}) {
  return {
    pathname: `/verify/2fa`,
    state: {
      isAuth: true,
      selectAccount,
      verifyType,
      loginInfo: {
        email,
        phone,
        userKey,
        memberKey: localStorage.getItem("r-mem"),
        hiddenKey: localStorage.getItem("r-hid"),
      },
    },
  };
}

export function resolveSwitchAccountNavigatePath({
  pathname,
  accountLevel,
  isEnabled,
}: {
  pathname?: string;
  accountLevel: LEVEL_TYPE;
  isEnabled: boolean;
}): string {
  let to = pathname;
  if (accountLevel === LEVEL_TYPE.EU) {
    if (!to) {
      to = `/recorders/list`;
    }
    if (to === "/subscription/organization") {
      to = "/subscription/organization/history";
    }
  } else if (!isEnabled) {
    if (accountLevel !== LEVEL_TYPE.DW) {
      to = `/dashboard/map`;
    } else {
      to = `/dashboard/admin`;
    }
  } else if (!to) {
    to = `/account`;
  }
  return to as string;
}

export const normalizeMenuPath = (p: string) => {
  if (!p) return "";
  return p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
};

export const hasPermissionForPath = ({
  pathname,
  account,
  checkRolePermission,
  unleashFlags,
}: {
  pathname: string;
  account: ProfileAccountInfo;
  checkRolePermission: CheckRolePermissionFn;
  unleashFlags: Record<string, boolean>;
}) => {
  const menusForRouting = buildMenuListsForAccount({
    account,
    checkRolePermission,
    unleashFlags,
  });
  const menu =
    menusForRouting.find((item) =>
      pathname.startsWith(item.includeRouteName || "")
    ) || null;
  return checkPermissionChildren({
    targetMenu: menu,
    account,
    pathname: pathname,
    checkRolePermission,
  });
};

export const PERMISSION_REDIRECT_CHAIN_TTL_MS = 2000;
export const PERMISSION_REDIRECT_CHAIN_MAX = 4;

export const buildPermissionLocationKey = (
  pathname: string,
  accountId: string,
  roleId: string
) => `${accountId}:${roleId}:${normalizeMenuPath(pathname)}`;

export const createPermissionRedirectGuard = () => {
  let visited: string[] = [];
  let expiresAt = 0;

  const reset = () => {
    visited = [];
    expiresAt = 0;
  };

  const prune = () => {
    if (expiresAt && Date.now() > expiresAt) {
      reset();
    }
  };

  const wouldLoop = (fromKey: string, toKey: string) => {
    prune();
    if (fromKey === toKey) {
      return true;
    }
    if (visited.includes(toKey)) {
      return true;
    }
    if (visited.length >= PERMISSION_REDIRECT_CHAIN_MAX) {
      return true;
    }
    return false;
  };

  const record = (fromKey: string, toKey: string) => {
    prune();
    if (!visited.includes(fromKey)) {
      visited.push(fromKey);
    }
    if (!visited.includes(toKey)) {
      visited.push(toKey);
    }
    expiresAt = Date.now() + PERMISSION_REDIRECT_CHAIN_TTL_MS;
  };

  return { reset, wouldLoop, record };
};

export type PermissionRedirectGuard = ReturnType<
  typeof createPermissionRedirectGuard
>;
